import { render } from "./FrameJsonAi1.vue?vue&type=template&id=5283d02c&scoped=true"
import script from "./FrameJsonAi1.vue?vue&type=script&lang=js"
export * from "./FrameJsonAi1.vue?vue&type=script&lang=js"

import "./FrameJsonAi1.vue?vue&type=style&index=0&id=5283d02c&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5283d02c"]])

export default __exports__